export enum ReferenceType {
  USER = "USER",
  PROJECT = "PROJECT",
  TIP = "TIP",
  MILESTONE = "MILESTONE",
  EPIC = "EPIC",
  IDEA = "IDEA",
  TEAM = "TEAM",
  SPRINT = "SPRINT",
  ITEM = "ITEM",
  TASK = "TASK",
  FILE = "FILE",
  FILE_LINK = "FILE_LINK",
  PREVIOUS_TASK_OWNER = "PREVIOUS_TASK_OWNER"
}
